import { render } from "./InputRadio.vue?vue&type=template&id=57b8ab1c&ts=true"
import script from "./InputRadio.vue?vue&type=script&lang=ts"
export * from "./InputRadio.vue?vue&type=script&lang=ts"

import "./InputRadio.vue?vue&type=style&index=0&id=57b8ab1c&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__